import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../api/client";

interface LoginPayload {
  username: string;
  password: string;
}

interface LoginResponse {
  ok: boolean;
  code: string;
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation<LoginResponse, ApiError, LoginPayload>({
    mutationFn: (payload) => apiPost<LoginResponse>("/api/auth/pm/login", payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["pm-session"] }),
  });
}
